import { getFirstMediaType } from '@scalar/helpers/http/get-first-media-type';
import { getExampleValue, getExplicitExampleText } from './get-example-value.js';
import { getExample } from '../request-example/builder/helpers/get-example.js';
/** Resolve new and legacy example fields without serializing parameter-level wire text again. */
export const getParameterExample = (parameter, exampleName) => {
    const authored = getExample({ ...parameter, content: undefined, schema: undefined }, exampleName, undefined);
    const example = authored ?? getExample(parameter, exampleName, undefined);
    const selected = getExampleValue(example);
    const contentType = 'content' in parameter ? getFirstMediaType(parameter.content)?.[0] : undefined;
    const mediaText = contentType ? getExplicitExampleText(selected, contentType) : undefined;
    return {
        example,
        value: contentType && selected && !(authored && selected.source === 'serialized')
            ? (mediaText ?? selected.value)
            : selected?.value,
        mediaSerialized: contentType !== undefined && mediaText !== undefined && !(authored && selected?.source === 'serialized'),
        serialized: authored !== undefined && selected?.source === 'serialized',
    };
};
